import React from 'react'
import styles from './UIGameCardAnimator.module.scss'
import {UIGameCardAnimatorItem} from './UIGameCardAnimatorItem.tsx'
import {useGameStore} from '../../store/GameStoreContext.ts'

export const UIGameCardAnimator = () => {
    const cards = useGameStore((state) => state.gameCardAnimator.cardsAnimating)

    return (
        <div className={styles.container}>
            {cards.map((card) => (
                <UIGameCardAnimatorItem key={card.id} {...card} />
            ))}
        </div>
    )
}
